import React, { Fragment } from "react";
import { useEffect } from "react";
import { DataTable } from "../../../components";
import "./tabela.scss";

export default function Tabela({ graph, changeCheckBox, isCheckedCheckBox }) {
  const test = () => {
    const data = [];

    graph.agrupamentos[ 0 ].data.forEach(( e, i ) => {
      data.push( e );
    });

    graph.agrupamentos[ 1 ].data.forEach(( e, i ) => {
      data[ i ] = {
        ...data[ i ],
        programaMedia: e.media,
        programaN: e.n,
      };
    });

    graph.agrupamentos[ 2 ].data.forEach(( e, i ) => {
      data[ i ] = {
        ...data[ i ],
        fazendaG2Media: e.media,
        fazendaG2N: e.n,
      };
    });
    
    return data;
  };

  useEffect(() => {
    if( graph )
      test();
  }, [ graph ]);

  return (
    <section>
      <DataTable
        columns={[
          {
            key: 'media',
            value: 'Média'
          },

          {
            key: 'n',
            value: 'N'
          },

          {
            key: 'programaMedia',
            value: 'Média'
          },

          {
            key: 'programaN',
            value: 'N'
          },

          {
            key: 'fazendaG2Media',
            value: 'Média'
          },

          {
            key: 'fazendaG2N',
            value: 'N'
          },
        ]}
        uniqueColumn={{
          key: 'safra',
          value: 'Safra'
        }}
        items={ test()}
        showCheckBox
        isChecked={( row ) => isCheckedCheckBox( row.safra )}
        changeCheckBox={( row ) => changeCheckBox( row )}
        title="Evolução do Rebanho"
        titles={ graph.agrupamentos.map(( agrupamento, index ) => {
          if( index === 0 )
            return 'Fazenda';

          return agrupamento.legenda;
        })}
        
      />
    </section>
  );
}
